import React from "react";
import "./index.scss";

const classPrefix = "yfm-product-detail-bottom-bar-skeleton";

const BottomBarSkeleton: React.FC = () => {
  return (
    <div className={`${classPrefix}__wrapper`}>
      <div className={`${classPrefix} yfm-app-page-width-fix`}>
        <div className={`${classPrefix}__btn yfm-is-skeleton`}>
          Add To Showcase
        </div>
        <div className={`${classPrefix}__btn yfm-is-skeleton`}>
          Request Free Sample
        </div>
      </div>
    </div>
  );
};

export default BottomBarSkeleton;
